import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Homepage from "../view/Homepage";
import About from "../view/About";
import Network from "../view/Network";
import Career from "../view/Career";
import Contact from "../view/Contact";
import Infrastructure from "../view/Infrastructure";
import WareHouse from "../view/WareHouse";
import Terms from "../view/Terms";



import Login from "../Login";
import Admin from "../Admin";
// import PrivateRoutes from "./PrivateRoutes";


const MainRoute = () => {
  return (
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="about" element={<About />} />
        <Route path="infrastructure" element={<Infrastructure />} />
        <Route path="franchise" element={<WareHouse />} />
        <Route path="network" element={<Network />} />
        <Route path="career" element={<Career />} />
        <Route path="contact" element={<Contact />} />
        <Route path="terms" element={<Terms />} />
    
        <Route path="*" element={<Navigate to="/" />} />

        <Route path="/login" element={<Login />} />

        {/* Protected Route */}
        <Route
          path="/admin"
          element={
            // <PrivateRoutes>
              <Admin />
            // </PrivateRoutes>
          }
        />
      </Routes>
  );
};

export default MainRoute;
